<template>
  <div class="Card">
    <div class="Card-Container" :class="class_container" @mouseenter="remove" @mouseleave="add">
      <div class="Card-Image">
        <img v-if="hidden" :src="`/img/${this.img.black}`" alt="Card Photo"/>
        <img v-else :src="`/img/${this.img.color}`" alt="Card Photo"/>
      </div>
      <div class="Card-Data">
        <div class="Card-Data-Social-Container">
          <div class="Card-Data-Social" v-for="(social, index) in this.socials" :key="index">
                        <span v-if="social.disabled">
                            <img class="Except"
                                 :src="`/img/${social.src}`"
                                 :alt="social.alt"/>
                        </span>
            <a v-else :href="social.href" target="_blank">
              <img class="Except"
                   :src="`/img/${social.src}`"
                   :alt="social.alt"/>
            </a>
          </div>
        </div>
      </div>
      <div class="Card-Bottom">
        <div class="Card--name">{{ this.firstname }} {{ this.name }}</div>
        <div class="Card--job">{{ this.job }}</div>
        <img src="/img/global/plus.svg" alt="Icon Plus"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Card',
  props: ['img', 'name', 'firstname', 'job', 'text', 'socials'],
  data() {
    return {
      hidden: true
    }
  },
  computed: {
    class_container() {
      const classes = []
      if (this.hidden) classes.push('hide')
      return classes
    }
  },
  methods: {
    add() {
      this.hidden = true;
    },
    remove() {
      this.hidden = false;
    },
  }
}
</script>

<style scoped>
/* 
* Global 
*/
.Card {
  overflow: hidden;
  width: 285px;
  height: 470px;
  border-radius: 5px 5px 0 0;
  background-color: #FFFFFF;
  margin: 75px 50px;
  box-shadow: 0px 10px 30px 5px rgba(119, 119, 119, 0.1);
}

.Card-Container * {
  pointer-events: none;
}

.Except {
  pointer-events: initial;
}

.hide .Card-Data {
  display: none;
}

.Card-Container {
  position: relative;
  width: 100%;
  height: 500px;
}

.Card-Bottom, .Card-Image, .Card-Data {
  position: absolute;
}

/* 
* Text
*/
.Card-Data {
  top: 40%;
  width: 100%;
}

.Card-Data-Text div {
  font-size: 14px;
}

/* 
* Social
*/
.Card-Data-Social-Container {
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  margin-top: 40px;
  transition: all 0.5s ease-out;
}

.Card-Data-Social:not(.Card-Data-Social:last-child) {
  margin-right: 35px;
}

.Card-Data-Social img {
  width: 30px;
  border-radius: 5px;
}

/* 
* Image
*/
.hide .Card-Image {
  top: 50px;
  left: calc(50% - 75px);
}

.Card-Image {
  top: 20px;
  left: calc(50% - 75px);
  transition: all 0.5s ease-out;
}

.Card-Image img {
  width: 150px;
  height: 150px;
  clip-path: ellipse(50% 50%);
}

/* 
* Bottom 
*/
.Card-Bottom {
  color: #FFFFFF;
  background-color: #00AEB0;
  margin-bottom: auto;
  width: 535px;
  height: 444px;
  left: calc(50% - 267.5px);
  bottom: -300px;
  padding-top: 5px;
  transition: all 0.5s ease-out;
}

.hide .Card-Bottom {
  bottom: -200px;
  padding-top: 25px;
  border-radius: 50%;
}

.Card--name {
  line-height: 30px;
}

.Card--job {

}

.Card-Bottom img {
  display: none;
}

.hide .Card-Bottom img {
  display: inline-block;
}

.Card-Bottom div:first-of-type {
  font-family: 'GothamBold';
  font-size: 20px;
  padding: 20px 0 10px 0;
}

.Card-Bottom div:last-of-type {
  font-size: 13px;
}

.Card-Bottom img {
  margin-top: 40px;
  width: 50px;
}
</style>